import { render, staticRenderFns } from "./SuccessResetPassword.vue?vue&type=template&id=edebf578&scoped=true&"
import script from "./SuccessResetPassword.vue?vue&type=script&lang=js&"
export * from "./SuccessResetPassword.vue?vue&type=script&lang=js&"
import style0 from "./SuccessResetPassword.vue?vue&type=style&index=0&id=edebf578&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edebf578",
  null
  
)

export default component.exports